import { COMPANY_ADDRESS_FULL, MEMBER_SEARCH_URL, CONTACT_EMAIL, CONTACT_NOTE } from '../constants';

function VisitSection() {
  return (
    <section id="visit" className="bg-plum text-petal">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 lg:grid-cols-2 lg:items-center">
        <div className="min-w-0">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-blush">Take the next step</p>
          <h2 className="font-display mt-4 text-4xl leading-tight sm:text-5xl">Find your connection.</h2>
          <p className="mt-6 max-w-lg leading-8 text-petal/90">{CONTACT_NOTE}</p>
          <a href={MEMBER_SEARCH_URL} className="mt-8 inline-flex rounded-pill bg-blush px-6 py-3.5 font-semibold text-plum transition hover:bg-petal">
            Find a member program <span aria-hidden="true" className="ml-3">↗</span>
          </a>
        </div>
        <div className="min-w-0 rounded-3xl border border-petal/20 bg-petal/5 p-8 sm:p-10">
          <h3 className="font-display text-2xl">Get in touch</h3>
          <p className="mt-6 text-xs font-bold uppercase tracking-widest text-blush">General inquiries</p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="mt-3 block [overflow-wrap:anywhere] font-semibold underline decoration-petal/40 underline-offset-4">{CONTACT_EMAIL}</a>
          <p className="mt-8 text-xs font-bold uppercase tracking-widest text-blush">Mailing address</p>
          <address className="mt-3 text-lg not-italic leading-8">{COMPANY_ADDRESS_FULL}</address>
          <p className="mt-5 text-sm text-petal/80">For correspondence. Contact ADI online before arranging a visit.</p>
        </div>
      </div>
    </section>
  );
}

export default VisitSection;
